module.exports = __webpack_public_path__ + "static/clauserpaws-1f672c5e51aecbbc11ecf280e7ffcd73.png";